module.exports = __webpack_public_path__ + "static/img/icon-insurance-05.f74c9352.png";